module.exports = __webpack_public_path__ + "img/lawContrant1.32925949.png";